/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/program.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ProgramType } from "./common_enums";
import { PlaybackType } from "./common_enums";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Program
 */
export interface Program {
    /**
     * @generated from protobuf field: optional string program_id = 1;
     */
    program_id?: string;
    /**
     * @generated from protobuf field: optional string series_season_number = 2;
     */
    series_season_number?: string;
    /**
     * @generated from protobuf field: optional string series_id = 3;
     */
    series_id?: string;
    /**
     * @generated from protobuf field: optional string program_name = 4;
     */
    program_name?: string;
    /**
     * @generated from protobuf field: optional string series_name = 5;
     */
    series_name?: string;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.PlaybackType playback_type = 6;
     */
    playback_type?: PlaybackType;
    /**
     * @generated from protobuf field: optional string series_episode_number = 7;
     */
    series_episode_number?: string;
    /**
     * @generated from protobuf field: optional string editorial_tag = 8;
     */
    editorial_tag?: string;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.ProgramType program_type = 9;
     */
    program_type?: ProgramType;
}
// @generated message type with reflection information, may provide speed optimized methods
class Program$Type extends MessageType<Program> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Program", [
            { no: 1, name: "program_id", kind: "scalar", localName: "program_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Refer to molotov episode id ?" } },
            { no: 2, name: "series_season_number", kind: "scalar", localName: "series_season_number", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Series Season Number for Program Types Episode or Extra." } },
            { no: 3, name: "series_id", kind: "scalar", localName: "series_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Series ID for Program Types Episode or Extra." } },
            { no: 4, name: "program_name", kind: "scalar", localName: "program_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Star Wars: A New Hope", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Program Name." } },
            { no: 5, name: "series_name", kind: "scalar", localName: "series_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Dexter", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Series Name." } },
            { no: 6, name: "playback_type", kind: "enum", localName: "playback_type", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.PlaybackType", PlaybackType], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "live", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of stream playing." } },
            { no: 7, name: "series_episode_number", kind: "scalar", localName: "series_episode_number", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Series Episode Number." } },
            { no: 8, name: "editorial_tag", kind: "scalar", localName: "editorial_tag", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "BHM", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 9, name: "program_type", kind: "enum", localName: "program_type", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.ProgramType", ProgramType], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Extra", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Content Category" } }
        ]);
    }
    create(value?: PartialMessage<Program>): Program {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Program>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Program): Program {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string program_id */ 1:
                    message.program_id = reader.string();
                    break;
                case /* optional string series_season_number */ 2:
                    message.series_season_number = reader.string();
                    break;
                case /* optional string series_id */ 3:
                    message.series_id = reader.string();
                    break;
                case /* optional string program_name */ 4:
                    message.program_name = reader.string();
                    break;
                case /* optional string series_name */ 5:
                    message.series_name = reader.string();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.PlaybackType playback_type */ 6:
                    message.playback_type = reader.int32();
                    break;
                case /* optional string series_episode_number */ 7:
                    message.series_episode_number = reader.string();
                    break;
                case /* optional string editorial_tag */ 8:
                    message.editorial_tag = reader.string();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.ProgramType program_type */ 9:
                    message.program_type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Program, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string program_id = 1; */
        if (message.program_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.program_id);
        /* optional string series_season_number = 2; */
        if (message.series_season_number !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.series_season_number);
        /* optional string series_id = 3; */
        if (message.series_id !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.series_id);
        /* optional string program_name = 4; */
        if (message.program_name !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.program_name);
        /* optional string series_name = 5; */
        if (message.series_name !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.series_name);
        /* optional fubo.tv.proto.common.v3.generic.PlaybackType playback_type = 6; */
        if (message.playback_type !== undefined)
            writer.tag(6, WireType.Varint).int32(message.playback_type);
        /* optional string series_episode_number = 7; */
        if (message.series_episode_number !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.series_episode_number);
        /* optional string editorial_tag = 8; */
        if (message.editorial_tag !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.editorial_tag);
        /* optional fubo.tv.proto.common.v3.generic.ProgramType program_type = 9; */
        if (message.program_type !== undefined)
            writer.tag(9, WireType.Varint).int32(message.program_type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Program
 */
export const Program = new Program$Type();
